import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import languageDetector from 'i18next-browser-languagedetector';
import {initReactI18next} from 'react-i18next';

i18n.use(Backend).use(languageDetector).use(initReactI18next).init({
    backend:{
        //translation file path
    loadPath:"/assets/i18n/{{ns}}/{{lng}}.json",
    },
    fallbackLng:"en",
    //dibasle in production
    debug:false,
    //Multiple files for big project from translation distribution
    ns:["common","dashboard","profile"],

    interpolation:{
        escapeValue:false,
        formatSeparator:",",
    },
    react:{
        useSuspense: false

    }
});

export default i18n;